import { render, staticRenderFns } from "./SendCredits.vue?vue&type=template&id=1836ac09&"
import script from "./SendCredits.vue?vue&type=script&lang=js&"
export * from "./SendCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports